import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Flex, Form, Input, Modal, Typography } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useDeviceId } from '../../-components/device-id-context';
import { WebCrm_Webhook_API } from '../../../../../api/attachments.api';
import { ReactComponent as CommentIcon } from "../../../../../assets/icons/comment_icon.svg";
import { getCurrentApplicationData, leaveTheRate } from '../../../../../Store/ApplicationsReducer/applicationsActions';
import './task-review.css';
import { Title } from './title';

function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

export const TaskReview = (props) => {
    const { uuid } = props;
    const task = useSelector(state => state.applications.currentApplicationData);
    const clientName = useSelector(state => state.applications.clientName)

    const [review, setReview] = useState(0);
    const [specialistComment, setSpecialistComment] = useState('')
    const [reviewModalVisible, setReviewModalVisible] = useState(false);
    const deviceId = useDeviceId()
    const dispatch = useDispatch();
    const isLike = review === 1;
    const isDisLike = review === -1;
    const hasComment = !!task?.commentstr;

    const sendReview = async (rating, comment) => {
        await dispatch(leaveTheRate({
            hash: uuid, rating, comment,
            responsible_id: task.responsible_uuid,
        }));
        await dispatch(getCurrentApplicationData(uuid));
    };

    const handleReviewChange = (value) => {
        setReview(value);
        sendReview(value, specialistComment);
    };

    const like = () => {
        handleReviewChange(1);
    };
    const dislike = () => {
        handleReviewChange(-1);
    };

    useEffect(() => {
        setReview(task?.rate);
    }, [task?.rate])

    useEffect(() => {
        setSpecialistComment(task?.commentstr);
    }, [task?.commentstr])

    const query = useQuery()
    useEffect(() => {
        if (query.get("openComment") === "1") {
            setReviewModalVisible(true)
        }
    }, [query])

    //#region responsible photo
    const [image, setImage] = useState(undefined);
    const fetchPhoto = useCallback(async () => {
        if (!task?.responsible_uuid) return;
        try {
            const photo64 = await WebCrm_Webhook_API.Request.getPhotoByImplementerUUID(task?.responsible_uuid);
            if (photo64?.length > 128) {
                setImage(`data:image/jpeg;base64,${photo64}`)
            }
        } catch (error) { }
    }, [task?.responsible_uuid]);

    useEffect(() => {
        fetchPhoto();
    }, [fetchPhoto, task?.responsible_uuid]);
    //#endregion

    const [modalForm] = Form.useForm();
    const onFinish = async (values) => {
        const { comment } = values;
        if (!comment || comment.trim() === '') return;
        setSpecialistComment(comment);
        await sendReview(review, comment);
        setReviewModalVisible(false);
        modalForm.resetFields();
    }

    return (
        <>
            <Typography.Text style={{ color: '#4D525B' }}>
                оцените мою работу
            </Typography.Text>
            <Flex justify='space-evenly' align='center' style={{ width: '100%' }} gap='small'>
                {isLike ? <button
                    className={`likeBtn likeBtn-active`}
                    onClick={like}
                    disabled={isLike || isDisLike ? true : false}
                /> : null}
                {isDisLike ? <button
                    className={`dislikeBtn dislikeBtn-active`}
                    onClick={dislike}
                    disabled={isLike || isDisLike ? true : false}
                /> : null}

                {!isLike && !isDisLike ? <>
                    <div className={`likeBtn`} onClick={like} />
                    <div className={`dislikeBtn`} onClick={dislike} />
                </> : null}

                {hasComment && (
                    <CommentIcon style={{ cursor: 'pointer', }}
                        onClick={() => setReviewModalVisible(true)}
                    />
                )}

            </Flex>
            {!hasComment && (
                <Button type='text' style={{ color: '#4D525B' }}
                    onClick={() => setReviewModalVisible(true)}
                >Оставить отзыв</Button>
            )}
            <Modal open={reviewModalVisible} width={800} centered footer={null} onCancel={() => setReviewModalVisible(false)} title='Оставить отзыв'>
                <Flex vertical gap={16}>
                    <Flex gap={16} justify='space-between' align='center'>
                        <Flex vertical style={{ padding: 4 }}>
                            <Avatar
                                size={100}
                                icon={image ? <img src={image} alt={task?.responsible || 'Неизвестный сотрудник'} style={{ width: '100%', height: '100%', borderRadius: '50%' }} /> : <UserOutlined />}
                            />
                        </Flex>
                        <Flex vertical style={{ width: '100%' }}>
                            <Typography.Title level={4} style={{ margin: 0, color: '#4D525B' }}>
                                {task.responsible || 'Неизвестный сотрудник'}
                            </Typography.Title>
                            <Flex gap={32} align='center' style={{ width: '100%' }}>
                                <Typography.Text style={{ color: '#4D525B', width: 'fit-content' }}>
                                    IT {task?.phonenumber}
                                </Typography.Text>
                                <Typography.Link style={{ color: '#4D525B', width: 'fit-content' }} href='tel:+77273901112'>
                                    +7 727 390 1112
                                </Typography.Link>
                            </Flex>
                            <Typography.Text style={{ color: '#E34A4E', fontWeight: 'bold' }}>
                                Заявка № {task.humanId}
                            </Typography.Text>
                        </Flex>
                        <Flex gap={16} align='center' justify='flex-end'>
                            {<button
                                className={`reviewLikeBtn ${isLike ? "reviewLikeBtn-active" : ""}`}
                                onClick={like}
                                disabled={isLike || isDisLike ? true : false}
                            />}
                            {<button
                                className={`reviewDislikeBtn ${isDisLike ? "reviewDislikeBtn-active" : ""}`}
                                onClick={dislike}
                                disabled={isLike || isDisLike ? true : false}
                            />
                            }
                        </Flex>
                    </Flex>
                    <Flex vertical gap={8}>
                        {hasComment ? (
                            <>
                                <Flex vertical gap={16}>
                                    <Flex vertical>
                                        <Title style={{ margin: 0 }}>Отзыв клиента</Title>
                                        <Typography.Text>
                                            {task?.commentstr}
                                        </Typography.Text>

                                    </Flex>
                                    <Flex vertical>
                                        <Typography.Text style={{ color: '#4D525B', fontWeight: 'bold' }}>
                                            ID устройства {deviceId.deviceId}
                                        </Typography.Text>
                                        <Typography.Text style={{ color: '#4D525B' }}>
                                            {clientName?.name}
                                        </Typography.Text>
                                    </Flex>
                                </Flex>
                            </>
                        ) : (<Form
                            form={modalForm}
                            layout="vertical"
                            onFinish={onFinish}
                            style={{ width: '100%' }}
                            requiredMark={false}
                        >
                            <Form.Item
                                name="comment"
                                style={{ margin: 0 }}
                            >
                                <Input.TextArea size="large" rows={4} placeholder="Пожалуйста, напишите несколько слов о том что понравилось в нашей работе, а что можно сделать лучше. Это поможет улучшить наш сервис." />
                            </Form.Item>
                            <Form.Item shouldUpdate style={{ marginTop: 8, }}>
                                {() => (
                                    <Button
                                        size="large"
                                        type="primary"
                                        htmlType="submit"
                                        style={{ width: '100%' }}
                                        disabled={!modalForm.getFieldValue('comment') || modalForm.getFieldValue('comment').trim() === ''}
                                    >
                                        Оставить отзыв
                                    </Button>
                                )}
                            </Form.Item>
                        </Form>)}
                    </Flex>
                </Flex>
            </Modal>
        </>
    )
}